import { render, staticRenderFns } from "./RoyaltiesDetail.vue?vue&type=template&id=855936b0&scoped=true"
import script from "./RoyaltiesDetail.vue?vue&type=script&lang=js"
export * from "./RoyaltiesDetail.vue?vue&type=script&lang=js"
import style0 from "./RoyaltiesDetail.vue?vue&type=style&index=0&id=855936b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855936b0",
  null
  
)

export default component.exports